import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { ingestWmFromUrl, readStoredMember, AWAKE_DASHBOARD_URL } from "./awake";

const AwakeMemberContext = createContext(null);

export function AwakeMemberProvider({ children }) {
  const [member, setMember] = useState(null);

  useEffect(() => {
    // On initial mount: ingest token from URL if present, else read session.
    const m = ingestWmFromUrl();
    if (m) setMember(m);
  }, []);

  // Re-check session on visibility change (catches the case where the user came
  // back to the tab and the token has expired in the background).
  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === "visible") {
        const m = readStoredMember();
        setMember(m);
      }
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, []);

  const value = useMemo(
    () => ({
      member,
      isMember: !!member,
      memberEmail: member?.e || null,
      memberPlan: member?.p || null,
      dashboardUrl: AWAKE_DASHBOARD_URL,
    }),
    [member]
  );

  return (
    <AwakeMemberContext.Provider value={value}>
      {children}
    </AwakeMemberContext.Provider>
  );
}

export function useAwakeMember() {
  const ctx = useContext(AwakeMemberContext);
  if (!ctx) {
    // graceful fallback if used outside the provider (shouldn't happen)
    return {
      member: null,
      isMember: false,
      memberEmail: null,
      memberPlan: null,
      dashboardUrl: AWAKE_DASHBOARD_URL,
    };
  }
  return ctx;
}
